import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import EditableInfo from '../../reusable/EditableInfo';
import userUpdateShape from '../../../shapes/userUpdateShape';
import setProfileSchema from '../../../schemas/setProfile';
import { currentLanguage } from '../../../i18n';

const SettingsAccount = (props) => {
  const {
    t, user, updateUserProfile, openUpdateProfileModal, closeUpdateProfileModal,
  } = props;
  const {
    firstName, lastName, nickname, mobileNumber, email,
  } = user;
  const reduxState = {
    ...user.update,
    firstName,
    lastName,
    nickname,
    mobileNumber,
    email,
    language: currentLanguage(),
  };
  return (
    <EditableInfo
      schema={setProfileSchema}
      shape={userUpdateShape}
      modalSize="tiny"
      title={t('accountConfig.modal-title')}
      reduxState={{ ...reduxState }}
      isModalOpen={user.update.isModalOpen}
      openModalAction={openUpdateProfileModal}
      closeModalAction={closeUpdateProfileModal}
      submitAction={updateUserProfile}
    />
  );
};

SettingsAccount.propTypes = {
  t: PropTypes.func.isRequired,
  updateUserProfile: PropTypes.func.isRequired,
  openUpdateProfileModal: PropTypes.func.isRequired,
  closeUpdateProfileModal: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
};

export default translate()(SettingsAccount);



// WEBPACK FOOTER //
// ./src/components/Settings/user/SettingsAccount.js